export default {
  init() {
    // JavaScript to be fired on the about us page

  },
  finalize() {
    var $header = $('header.main-navigation');
    var $filter = $('.show-product-filter-container');
    var $shippingInfoContainer = $('.shipping-info-container');
    var $sidebar = $('.sidebar');

    var $headerHeight = $header.outerHeight();
    var $filterOffsetTop = $filter.offset().top;

    $(window).on('resize', function () {
      $headerHeight = $header.outerHeight();
      $filterOffsetTop = $filter.offset().top;
    }).trigger('resize');

    $('.bapf_body li').has('ul').addClass('category-childs-container');

    $('#showProductFilter').on('click', function () {
      $sidebar.toggleClass('show-sidebar');
      $sidebar.css('height', 'calc(100% - ' + $headerHeight + 'px - ' + $filter.outerHeight() + 'px)');
      
      $('.icon-filter').toggleClass('d-none');
      $('.icon-close').toggleClass('d-none');
      $('html').css('overflow', $sidebar.hasClass('show-sidebar') ? 'hidden' : '');

      if ($('.icon-close').hasClass('d-none')) {
        $sidebar.css('height', '');

        if ($(window).scrollTop() <= $filterOffsetTop - $headerHeight) {
          $filter.removeClass('sticky');
          $filter.css('top', '');
          $filter.css('background-color', 'white');
        }

        $(this).find('.btn').text('Produkte suchen/filtern');
      } else {
        $sidebar.css('height', 'calc(100% - ' + $headerHeight + 'px - ' + $filter.outerHeight() + 'px)');
        $filter.addClass('sticky');
        $filter.css('top', $headerHeight + 'px');
        $(this).find('.btn').text('Filter schließen');

        if ($('header.main-navigation').hasClass('navbar--scrolled')) {
          $filter.css('background-color', 'var(--secondary)');
        } else {
          $filter.css('background-color', 'white');
        }
      }
    });

    $(window).on('scroll', function () {
      if ($(window).width() < 1281) {
        if (!$sidebar.hasClass('show-sidebar')) {
          if ($(window).scrollTop() > $filterOffsetTop - $headerHeight) {
            $filter.addClass('sticky');
            $filter.css('top', $headerHeight + 'px');
            $shippingInfoContainer.css('margin-top', $filter.outerHeight() + 'px');
          } else {
            $filter.removeClass('sticky');
            $filter.css('top', '');
            $shippingInfoContainer.css('margin-top', '');
          }
        }
      }
    });
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/postTypeArchiveProduct.js